import {
    CartItemAddedProductVariantInput,
    CartItemToppingInput,
} from '@/features/graphql/generated/graphql'
import { FormAddonGroup } from '@/features/pos/components/ProductConfigurationModal/form/types'

export const mapFormAddonGroupToCartItemToppings = (
    group: FormAddonGroup
): CartItemToppingInput[] => {
    return Object.keys(group.addonQuantities).reduce<CartItemToppingInput[]>(
        (toppings, toppingUuid) => {
            const quantity = group.addonQuantities[toppingUuid]

            toppings.push({ toppingGroupUuid: group.id, toppingUuid, quantity })

            return toppings
        },
        []
    )
}

export const mapFormAddonGroupToCartItemAdditionProductVariants = (
    group: FormAddonGroup
): CartItemAddedProductVariantInput[] => {
    return Object.keys(group.addonQuantities).reduce<CartItemAddedProductVariantInput[]>(
        (productVariants, productVariantUuid) => {
            const quantity = group.addonQuantities[productVariantUuid]

            productVariants.push({ additionGroupUuid: group.id, productVariantUuid, quantity })

            return productVariants
        },
        []
    )
}
